/**
 * Joycelyn Fashion — Global Theme Controller
 */
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  // Insert dynamic spacer to preserve document flow height when pinned
  let spacer = document.getElementById('site-header-spacer');
  if (!spacer && header.parentNode) {
    spacer = document.createElement('div');
    spacer.id = 'site-header-spacer';
    spacer.style.display = 'none';
    header.parentNode.insertBefore(spacer, header.nextSibling);
  }

  let ticking = false;
  function updateHeader() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollY > 15) {
      if (!header.classList.contains('is-pinned')) {
        const h = header.offsetHeight;
        if (spacer && h > 0) {
          spacer.style.height = h + 'px';
          spacer.style.display = 'block';
        }
        header.classList.add('is-pinned');
        header.classList.add('is-scrolled');
      }
    } else {
      if (header.classList.contains('is-pinned')) {
        header.classList.remove('is-pinned');
        header.classList.remove('is-scrolled');
        if (spacer) {
          spacer.style.display = 'none';
        }
      }
    }
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', () => {
    if (header.classList.contains('is-pinned') && spacer) {
      spacer.style.height = header.offsetHeight + 'px';
    }
  }, { passive: true });

  updateHeader();
}

function initModals() {
  // Delegate click for modal triggers
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-open]');
    if (trigger) {
      e.preventDefault();
      const modalId = trigger.getAttribute('data-modal-open');
      const targetModal = document.getElementById(modalId);
      if (targetModal) {
        targetModal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    }

    const closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      e.preventDefault();
      const modal = closeBtn.closest('.modal-overlay');
      if (modal) {
        modal.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    }

    if (e.target.classList.contains('modal-overlay')) {
      e.target.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  });

  // ESC key listener
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal-overlay.is-active').forEach(m => {
        m.classList.remove('is-active');
      });
      const drawer = document.querySelector('.cart-drawer.is-open');
      if (drawer) drawer.classList.remove('is-open');
      const overlay = document.querySelector('.cart-drawer-overlay.is-active');
      if (overlay) overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  });
}

/**
 * Product Card Sliders & Hover Gallery Controller
 * Handles hover zones, dot interactions, and mouse leave resets
 */
function initProductCardSliders() {
  let isScrolling = false;
  let scrollDebounce = null;
  window.addEventListener('scroll', () => {
    isScrolling = true;
    clearTimeout(scrollDebounce);
    scrollDebounce = setTimeout(() => { isScrolling = false; }, 80);
  }, { passive: true });

  function switchSlide(card, index) {
    if (!card) return;
    const images = card.querySelectorAll('.card-slide-img');
    const dots = card.querySelectorAll('.card-slider-dot');

    if (!images.length) return;

    images.forEach(img => {
      const imgIdx = parseInt(img.getAttribute('data-index'), 10);
      if (imgIdx === index) {
        img.classList.add('is-active');
      } else {
        img.classList.remove('is-active');
      }
    });

    dots.forEach(dot => {
      const dotIdx = parseInt(dot.getAttribute('data-slide-to'), 10);
      if (dotIdx === index) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  // Hover zone & dot scrubbing (paused while scrolling for 60fps performance)
  document.addEventListener('mouseover', (e) => {
    if (isScrolling) return;
    const zone = e.target.closest('.card-hover-zone');
    if (zone) {
      const card = zone.closest('.product-card-masonry');
      const slideTo = parseInt(zone.getAttribute('data-slide-to'), 10);
      if (card && !isNaN(slideTo)) {
        switchSlide(card, slideTo);
      }
      return;
    }

    const dot = e.target.closest('.card-slider-dot');
    if (dot) {
      const card = dot.closest('.product-card-masonry');
      const slideTo = parseInt(dot.getAttribute('data-slide-to'), 10);
      if (card && !isNaN(slideTo)) {
        switchSlide(card, slideTo);
      }
    }
  });

  // Handle dot clicks (prevents card navigation)
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.card-slider-dot');
    if (dot) {
      e.preventDefault();
      e.stopPropagation();
      const card = dot.closest('.product-card-masonry');
      const slideTo = parseInt(dot.getAttribute('data-slide-to'), 10);
      if (card && !isNaN(slideTo)) {
        switchSlide(card, slideTo);
      }
    }
  });

  // Reset to primary image when cursor leaves product card
  document.addEventListener('mouseout', (e) => {
    if (isScrolling) return;
    const card = e.target.closest('.product-card-masonry');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) {
      return;
    }
    switchSlide(card, 0);
  });
}

/**
 * Full Product Card Clickability
 * Makes clicking anywhere on the card navigate to the product page,
 * while preventing navigation when interacting with quick buttons or slider controls.
 */
function initProductCardFullClick() {
  document.addEventListener('click', (e) => {
    // If clicked element is inside quick-add, modal trigger, dot, or form button/input, do not navigate
    if (e.target.closest('button, form, input, select, textarea, .card-slider-dots, .card-quick-add-capsule, [data-modal-open], [data-modal-close]')) {
      return;
    }

    const card = e.target.closest('.product-card-masonry');
    if (!card) return;

    const url = card.getAttribute('data-product-url') || card.querySelector('a.product-card-full-link')?.getAttribute('href') || card.querySelector('a')?.getAttribute('href');
    if (url) {
      if (e.metaKey || e.ctrlKey) {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    }
  });
}

function initThemeGlobal() {
  initStickyHeader();
  initModals();
  initProductCardSliders();
  initProductCardFullClick();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initThemeGlobal);
} else {
  initThemeGlobal();
}

window.Atelier = {
  toast(message) {
    let toastEl = document.getElementById('atelier-toast');
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.id = 'atelier-toast';
      toastEl.style.cssText = `
        position: fixed; bottom: 30px; left: 50%; transform: translateX(-50%);
        background: rgba(24, 21, 30, 0.95); backdrop-filter: blur(12px);
        border: 1px solid var(--color-purple); color: #fff;
        padding: 12px 28px; border-radius: 9999px; font-size: 0.78rem;
        letter-spacing: 0.1em; text-transform: uppercase; z-index: 100000;
        box-shadow: 0 12px 30px rgba(146, 75, 201, 0.3); transition: opacity 0.3s ease;
      `;
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.style.opacity = '1';
    setTimeout(() => { toastEl.style.opacity = '0'; }, 3500);
  }
};
